import script from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodSelector.vue?vue&type=style&index=0&id=b3563c1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3563c1a"]])

export default __exports__